import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { Url } from "../../config/config";
import useButtonLoader from "../../hooks/useButtonLoader";
import useFullPageLoader from "../../hooks/useFullPageLoader";

const Settings = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [iState, updateState] = useState({
    twitter: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    brochure: "",
  });

  const [webSettings, setWebSettings] = useState({
    _id: "63aa82e698409d29027173d2",
    contact_number: "",
    email: "",
    address: "",
    portfolio_status: false,
    brochure_status: false,
    corporateVideo: "",
  });

  const { twitter, instagram, linkedin, facebook, brochure } = iState;
  const [errorField, setErrorField] = useState({
    twitter: "",
    facebook: "",
    instagram: "",
    linkedin: "",
  });

  const { contact_number, email, address } = webSettings;

  const [settingErrorField, setSettingErrorField] = useState({
    contact_number: "",
    email: "",
    address: "",
    corporateVideo: "",
  });

  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );

  const [settingSubmitButtonElement, setSettingSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );
  //************************Handel OnChange***************************** */
  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    updateState({
      ...iState,
      [name]: value,
    });
  };

  //*********************store broacher file********************************** */
  const handleFileChange = (e) => {
    if (e.target.files[0].type === "application/pdf") {
      updateState({
        ...iState,
        brochure: e.target.files[0],
      });
    } else {
      toast.error("Please Select PDF file only");
    }
  };

  //*********************store corporate video********************************** */
  const handleVideoChange = (e) => {
    if (e.target.files[0].type === "video/mp4") {
      setWebSettings({
        ...webSettings,
        corporateVideo: e.target.files[0],
      });
    } else {
      toast.error("Please Select Video file only");
    }
  };

  //*********************Handel Social Links Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    if (!twitter) {
      errorField["twitter"] = "Please enter Twitter Link";
      formIsValid = false;
    }
    if (!instagram) {
      errorField["instagram"] = "Please enter Instagram Link";
      formIsValid = false;
    }
    if (!facebook) {
      errorField["facebook"] = "Please enter Facebook Link";
      formIsValid = false;
    }
    if (!linkedin) {
      errorField["linkedIn"] = "Please enter LinkedIn Link";
      formIsValid = false;
    }

    setErrorField(errorField);
    return formIsValid;
  };

  //*********************Handel Web Settings Validation********************************** */
  const handleSettingsValidation = () => {
    let errorField = {};
    let formIsValid = true;

    if (!contact_number) {
      errorField["contact_number"] = "Please Enter Contact Number";
      formIsValid = false;
    }
    if (!email) {
      errorField["email"] = "Please Enter Email Address";
      formIsValid = false;
    }
    if (!address) {
      errorField["address"] = "Please Enter Address";
      formIsValid = false;
    }

    setSettingErrorField(errorField);
    return formIsValid;
  };

  //*********************Update Social Links************************************ */
  const handelUpdate = async (event) => {
    try {
      event.preventDefault();
      if (handleValidation()) {
        setSubmitLoading(true);
        const res = await axios({
          url: `${Url}/socail/update_links`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          data: iState,
        });
        setSubmitLoading(false);
        if (res.data.status === 200) {
          toast.success(res.data.message);
          getSocialLinks();
        } else if (res.data.status === 419) {
          toast.error(res.data.message);
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //*********************Update Website Settings************************************ */
  const handelSettingUpdate = async (event) => {
    try {
      event.preventDefault();
      if (handleSettingsValidation()) {
        setSettingSubmitLoading(true);
        const res = await axios({
          url: `${Url}/socail/update_contact_details`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          data: webSettings,
        });
        setSettingSubmitLoading(false);
        if (res.data.status === 200) {
          toast.success(res.data.message);
          getWebSettings();
        } else if (res.data.status === 419) {
          toast.error(res.data.message);
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //***************Getting Social Links************** */
  const getSocialLinks = async () => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/socail/get_link`,
        method: "GET",
      });
      hideLoader();
      if (res.status === 200) {
        updateState(res.data.data.link || { ...iState });
      }
    } catch (err) {
      console.log(err);
    }
  };

  //***************Getting Website Settings************** */
  const getWebSettings = async () => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/socail/contact_details/63aa82e698409d29027173d2`,
        method: "GET",
      });
      hideLoader();
      if (res.status === 200) {
        // const {
        //   address,
        //   contactNumber,
        //   email,
        //   portfolioEnable,
        //   corporateVideo,
        //   brochureEnable,
        // } = res.data.data.contact;
        setWebSettings({
          ...webSettings,
          address: res.data.data?.contact?.address,
          contact_number: res.data.data?.contact?.contactNumber,
          email: email,
          portfolio_status: res.data.data?.contact?.portfolioEnable,
          brochure_status: res.data.data?.contact?.brochureEnable,
          corporateVideo: res.data.data?.contact?.corporateVideo,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getSocialLinks();
    getWebSettings();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {/* Website Setting Section */}
      <title>Settings</title>
      <div className="WrapperArea _add_partner">
        <div className="WrapperBox">
          {loader}
          <div className="Small-Wrapper">
            <h4 className="Title">Settings</h4>
            <form method="POST">
              <div className="PasswordArea">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group row my-2">
                      <label className="col-sm-10">Portfolio Status</label>
                      <div className="form-check form-switch  col-sm-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="status"
                          checked={webSettings.portfolio_status}
                          onChange={(e) =>
                            setWebSettings({
                              ...webSettings,
                              portfolio_status: e.target.checked,
                            })
                          }
                        />
                        <label className="form-check-label"></label>
                      </div>
                    </div>
                    <div className="form-group row my-2">
                      <label className="col-sm-10">
                        Download Brochure Status
                      </label>
                      <div className="form-check form-switch  col-sm-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="status"
                          checked={webSettings.brochure_status || false}
                          onChange={(e) =>
                            setWebSettings({
                              ...webSettings,
                              brochure_status: e.target.checked,
                            })
                          }
                        />
                        <label className="form-check-label"></label>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Contact Number</label>
                      <input
                        type="text"
                        value={webSettings.contact_number || ""}
                        onChange={(e) =>
                          setWebSettings({
                            ...webSettings,
                            contact_number: e.target.value,
                          })
                        }
                        name="contact_number"
                        className="form-control"
                        placeholder="Contact Number"
                      />
                      <span style={{ color: "red" }} className="error">
                        {settingErrorField.contact_number}
                      </span>
                    </div>
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        value={webSettings.email || ""}
                        onChange={(e) =>
                          setWebSettings({
                            ...webSettings,
                            email: e.target.value,
                          })
                        }
                        name="email"
                        className="form-control"
                        placeholder="Email"
                      />
                      <span style={{ color: "red" }} className="error">
                        {settingErrorField.email}
                      </span>
                    </div>
                    <div className="form-group">
                      <label>Address</label>
                      <textarea
                        value={webSettings.address || ""}
                        onChange={(e) =>
                          setWebSettings({
                            ...webSettings,
                            address: e.target.value,
                          })
                        }
                        name="address"
                        className="form-control"
                        placeholder="Address"
                      />
                      <span style={{ color: "red" }} className="error">
                        {settingErrorField.address}
                      </span>
                    </div>

                    <div className="form-group row">
                      <label>Corporate Video</label>
                      <div className="col-sm-9">
                        <input
                          type="file"
                          accept="video/mp4,video/x-m4v,video/*"
                          onChange={handleVideoChange}
                          name="corporateVideo"
                          className="form-control"
                          placeholder="Corporate Video"
                        />
                      </div>
                      <div className="col-sm-3 d-flex align-items-center">
                        {webSettings.corporateVideo && (
                          <a
                            href={webSettings.corporateVideo}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-play"></i>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="button_wrap">
                    <button
                      className="button"
                      onClick={handelSettingUpdate}
                      ref={settingSubmitButtonElement}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
            {/* Social Links Section */}
            <div className="my-3">
              <h4 className="Title">Add Social Links</h4>
              <form method="POST">
                <div className="PasswordArea">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Twitter</label>
                        <input
                          type="text"
                          value={twitter || ""}
                          onChange={handleInputChange}
                          name="twitter"
                          className="form-control"
                          placeholder="Twitter"
                        />
                        <span style={{ color: "red" }} className="error">
                          {errorField.twitter}
                        </span>
                      </div>
                      <div className="form-group">
                        <label>Facebook</label>
                        <input
                          type="text"
                          value={facebook || ""}
                          onChange={handleInputChange}
                          name="facebook"
                          className="form-control"
                          placeholder="Facebook"
                        />
                        <span style={{ color: "red" }} className="error">
                          {errorField.facebook}
                        </span>
                      </div>
                      <div className="form-group">
                        <label>Instagram</label>
                        <input
                          type="text"
                          value={instagram || ""}
                          onChange={handleInputChange}
                          name="instagram"
                          className="form-control"
                          placeholder="Instagram"
                        />
                        <span style={{ color: "red" }} className="error">
                          {errorField.instagram}
                        </span>
                      </div>
                      <div className="form-group">
                        <label>LinkedIn</label>
                        <input
                          type="text"
                          value={linkedin || ""}
                          onChange={handleInputChange}
                          name="linkedin"
                          className="form-control"
                          placeholder="LinkedIn"
                        />
                        <span style={{ color: "red" }} className="error">
                          {errorField.linkedin}
                        </span>
                      </div>

                      <div className="form-group row">
                        <label>Company Brochure (PDF Only)</label>
                        <div className="col-sm-9">
                          <input
                            type="file"
                            accept=".pdf"
                            onChange={handleFileChange}
                            name="brochure"
                            className="form-control"
                            placeholder="Company Brochure"
                          />
                        </div>
                        <div className="col-sm-3 d-flex align-items-center">
                          {brochure && (
                            <a href={brochure} target="_blank" rel="noreferrer">
                              <i className="fa fa-file"></i>
                            </a>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="button_wrap">
                      <button
                        className="button"
                        onClick={handelUpdate}
                        ref={submitButtonElement}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
